import React from 'react';
import ProcessLists from '../ProcessLists/ProcessLists';
import ProcessSubtitle from '../ProcessSubtitle/ProcessSubtitle';
import ProcessTitle from '../ProcessTitle/ProcessTitle';
import classes from "./Process.module.css";

export default function Process() {
    return (
        <section className={classes.Process} id="process">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <ProcessTitle />
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <ProcessSubtitle />
                    </div>
                    <div className="col-md-12">
                        <ProcessLists />
                    </div>
                </div>
            </div>
        </section>
    )
}
